import React from "react";

// components
import Bio from "../Bio";

// assets
import bioImg from "../../../assets/images/DanielGreen.jpg";

const DanielGBio = (props) => {
  const bioData = {
    title: "Daniel Green",
    title2: "Independent Director and Chairperson of the Audit Committee",
    hashName: "daniel-green",
    bio1: `Daniel Green has served as an independent director of the Company and Chairperson of the Audit Committee since April 2021. He also has served as the President of Woolf Farming & Processing since February 2024 and previously served as the Chief Financial Officer since January 2019. Woolf Farming & Processing grow, process and deliver healthy natural products to the food chain. As stewards of the land, Woolf Farming & Processing takes very seriously the obligation to manage the regions natural resources sustainably. Mr. Green has more than 20 years of experience in leadership roles within the agribusiness and manufacturing industries. In addition to healthy food production, Mr. Green and his team have established an industrial scale solar development portfolio with over 300 megawatts that will provide the California Central Valley region with clean energy for years to come. Prior to his current role, Mr. Green served as Chief Financial Officer of a large food company that supplied major multi-national branded companies such as Kraft Heinz, ConAgra and Campbell’s Soup with natural food ingredients. Mr. Green served in this role from March 2012 until January 2019. In addition, Mr. Green serves on the Executive Committee at the California League of Food Producers.`,
    bio2: `Mr. Green holds a Master of Business Administration from the University of Notre Dame and a Bachelor of Science in business administration from the University of Redlands.`,
    bio3: `Mr. Green is a valuable member of our board of directors because of extensive financial and management experience, including the management of digital assets such as cell towers, wireless easements and lease assignments, fiber networks, and edge computing`,
  };
  return (
    <Bio
      srcImg={bioImg}
      title1={bioData.title}
      title2={bioData.title2}
      hashName={bioData.hashName}
      bio1={bioData.bio1}
      bio2={bioData.bio2}
      bio3={bioData.bio3}
      closeBio={props.closeBio}
    />
  );
};

export default DanielGBio;
